import { Search, SentimentDissatisfied } from "@mui/icons-material";
import { Typography, Stack } from "@mui/material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import ProductCard from "./ProductCard";
import "./Products.css";
import Cart, { generateCartItemsFrom, getTotalCartValue } from "./Cart"



// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */
let timer;
let complete_products = []
const Products = () => {
  
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  

 
  const [data, setData] = useState([])

  const [total, setTotal] = useState(0)

  const { enqueueSnackbar } = useSnackbar();

  const performAPICall = async () => {
    let prod = await axios.get(`${config.endpoint}/products`).then(res => {
      console.log(res)
      setData(res.data)
      complete_products = res.data;
      console.log(res.data)
    }).catch(err => console.log(err))
  };

  

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    console.log(text)

    let d = await axios.get(`${config.endpoint}/products/search?value=${text}`).then((res) => {
      setData(res.data)
    }).catch((err) => {
      setData(null)
      enqueueSnackbar("No products found", {
        autoHideDuration:3000,
        variant:"error"
      })
    })
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
   const [search, setSearch] = useState("")
  const debounceSearch = (event, debounceTimeout) => {
    console.log(event.target.value)
    let inside = event.target.value
    if(timer)
      clearTimeout(timer)
    
    timer = setTimeout(() => performSearch(inside), debounceTimeout)

  };

  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */

  const [disp, setDisp] = useState()
  useEffect(() => {
    console.log("Did mount")
    performAPICall(); 
    fetchCart(localStorage.getItem("token"))
  }, [])
  
  useEffect(() => {
    setTotal(getTotalCartValue(disp))
  },[disp])
  // useEffect(async () => {
  //   let cart_data = await fetchCart(localStorage.getItem("token"))
  //   updateCartItems(cart_data, complete_products)
  // }, [data])

  const fetchCart = async (token) => {
    if (!token) return;

    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      let cart_data = await axios.get(`${config.endpoint}/cart`,{
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then((res) => {
        console.log(res)
        setDisp(generateCartItemsFrom(res.data, complete_products))
        return res
      })
      console.log(cart_data)
      return cart_data.data;
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  // const updateCartItems = (items = [], products = []) => {
  //   let update_cart = generateCartItemsFrom(items, products)
  //   setDisp(update_cart)
  // }
  
  
// TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
   const isItemInCart = (items=[], productId) => {
    console.log(items, productId)
    //let flag = false;
    
    for(let i=0;i<items.length;i++){
      if(items[i].productId === productId)
        return true
    }

    console.log("Coming out")
    return false;
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */

 /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    if(!token){
      enqueueSnackbar("Login to add an item to the Cart",{
        autoHideDuration: 3000,
        variant: "error"
      })
      return;
    }

    
    console.log(items)
    
    if(options.preventDuplicate){
      let check = isItemInCart(items, productId)

      if(check){
        enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.",
        {
          autoHideDuration: 3000,
          variant: "warning"
        })
        return;
      }
    }

    if(!options.preventDuplicate)
      for(let i=0;i<items.length;i++){
        if(items[i].productId === productId){
          console.log(qty)
          if(qty === 0)
            items.splice(i, 1);

          else{
            items[i].qty = qty
          }
          console.log(items)

          setTotal(getTotalCartValue(items))
          break;
        }
      }
    let send = {productId: productId, qty: qty}
    console.log(send)
    let url = `${config.endpoint}/cart`
    let res = await axios.post(url, send, {
      headers:{
        'Authorization': `Bearer ${token}`
      }
    }).then(res => {
      // if(options.preventDuplicate)
      console.log(res)
        setDisp(generateCartItemsFrom(res.data, complete_products))
    }).catch((err) => {
      console.log(err)
    })
    // updateCartItems(res, complete_products);
  
  }

  const ProductsItem = () => {
    if(localStorage.getItem("username")){
      return (
        <Grid container>
          <Grid item md={9}>
          {data === null ? (<Stack className="lpmp"><Typography><SentimentDissatisfied />No search results found!!</Typography></Stack>):
          (data.length === 0 ? 
          (<Stack className="lpmp"><CircularProgress /><Typography>Loading Products...</Typography></Stack>):
          (<Grid container spacing={2}>
            {
              data.map((item) => {
                return (
                  <Grid item xs={12} sm={6} md={4} key={item._id}>
                    <ProductCard product={item} key={item._id} handleAddToCart={addToCart} cartItem={disp} data={data}/>
                  </Grid>
                )
              })
            }
          </Grid>)
        )}
      </Grid>
      <Grid item md={3}>
        <Cart items={disp} handleQuantity={addToCart} total={total} isReadOnly={false}
      />
      </Grid>
    </Grid>
      )
    }

    return (
      <Grid container>
        <Grid item md={12}>
        {data === null ? (<Stack className="lpmp"><Typography>No search results found!!</Typography></Stack>):
        (data.length === 0 ? 
        (<Stack className="lpmp"><CircularProgress /><Typography>Loading Products...</Typography></Stack>):
        (<Grid container spacing={2}>
          {
            data.map((item) => {
              return (
                <Grid item xs={12} sm={6} md={4} key={item._id}>
                  <ProductCard product={item} key={item._id} handleAddToCart={addToCart} cartItem={disp} data={data}/>
                </Grid>
              )
            })
          }
        </Grid>)
      )}
    </Grid>
  </Grid>
    )

  }




  return (
    <div>
      <Header children={
        <TextField
        className="search-desktop"
        onChange={(e) => debounceSearch(e, 250)}
        // value={searchu}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />} hasHiddenAuthButtons={false}>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}

      </Header>
        <TextField
        className="search-mobile"
        size="small"
        fullWidth
        onChange={(e) => debounceSearch(e, 250)}
        // value={searchu}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />
      <br />
      <br />
      {/* Search view for mobiles */}
     <ProductsItem />
      <br />
      <br />
       <Grid container>
         <Grid item className="product-grid">
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
         </Grid>
         </Grid>
      <Footer />
    </div>
  );
};

export default Products;
